import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'qa-mock-phone',
  templateUrl: './mock-phone.component.html',
  styleUrls: ['./mock-phone.component.scss'],
  imports: [MatIcon, DatePipe],
})
export class MockPhoneComponent {
  date = new Date();

  constructor() {}
}
